module.exports = __webpack_public_path__ + "fonts/Roboto-Light-webfont.a990f611.eot";